module.exports = __webpack_public_path__ + "img/couponDefault.37c45f26.png";